import { render, staticRenderFns } from "./PersonalNote.vue?vue&type=template&id=2b09678c&scoped=true"
import script from "./PersonalNote.vue?vue&type=script&lang=js"
export * from "./PersonalNote.vue?vue&type=script&lang=js"
import style0 from "./PersonalNote.vue?vue&type=style&index=0&id=2b09678c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09678c",
  null
  
)

export default component.exports